import "core-js/modules/es.function.name.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4267612a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("✨ 朝旭行知录 ✨");

var _hoisted_2 = {
  class: "header-menu"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");

  var _component_kila_kila_admin_menu = _resolveComponent("kila-kila-admin-menu");

  var _component_el_drawer = _resolveComponent("el-drawer");

  return _openBlock(), _createElementBlock("header", null, [_createVNode(_component_router_link, {
    class: "header-title",
    to: "/"
  }, {
    default: _withCtx(function () {
      return [_hoisted_1];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item.name
    }, [_createVNode(_component_router_link, {
      to: item.href,
      class: "header-menu-item"
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_font_awesome_icon, {
          icon: item.icon,
          class: "header-icon"
        }, null, 8, ["icon"]), _createTextVNode(_toDisplayString(item.name), 1)];
      }),
      _: 2
    }, 1032, ["to"])]);
  }), 128))]), _createElementVNode("div", {
    id: "header-menu-button",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $setup.drawer = !$setup.drawer;
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'bars']
  })]), _createVNode(_component_el_drawer, {
    modelValue: $setup.drawer,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $setup.drawer = $event;
    }),
    direction: "ltr",
    "show-close": false,
    "with-header": false,
    size: "40%"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_kila_kila_admin_menu)];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}